import numpad from './themes/numpad';

export default name => {
  const themes = { numpad };
  return themes[name] || numpad;
};



// WEBPACK FOOTER //
// ./src/view/component/lib/react-numpad/styles/index.js